import { gateSentryLatestDetails, entranceSituationDetails, exportSituationDetails, faceEventDetails, faceVehicleMatchDetails} from './../api';
import {plant, getPlantGateSentry} from "../../../../api";
const gateSentryLatest = {
  namespaced: true,
  state: {
    entranceTotal: 0,
    entranceSituationResp: null,
    exportTotal: 0,
    exportSituationResp: null,
    gateSentryLatestResp: [],
    plantObj: null,
    plantGateSentryObj: null,
    faceEventTotal: 0,
    faceEventResp: null,
    faceVehicleMatchTotal: 0,
    faceVehicleMatchResp: null
  },
  mutations: {
    SENTRY_LATEST_DATA(state, data){
      state.gateSentryLatestResp = data;
    },
    ENTRANCE_SITUATION_DATA(state, data){
      state.entranceTotal = data.total;
      state.entranceSituationResp = (data.obj || []).map(item => ({
        ...item,
        dealStatusDescShowColor: true,
        dealStatusDescColor:  item.dealStatus == '9' ? 'red' : '#0e8eff',
      }));
    },
    EXPORT_SITUATION_DATA(state, data){
      state.exportTotal = data.total;
      state.exportSituationResp = (data.obj || []).map(item => ({
        ...item,
        dealStatusDescShowColor: true,
        dealStatusDescColor:  item.dealStatus == '9' ? 'red' : '#0e8eff',
      }));
    },
    PLANT(state, data) {
      state.plantObj = (data.obj || []).map(item => ({ key: item.plantName, value: item.plantCode }))
    },
    PLANT_GATESENTRY(state, data){
      state.plantGateSentryObj = data.obj;
    },
    FACE_EVENT_DATA(state, data){
      state.faceEventTotal = data.total;
      state.faceEventResp = data.obj || [];
    },
    FACE_VEHICLE_MATCH_DATA(state, data){
      state.faceVehicleMatchTotal = data.total;
      state.faceVehicleMatchResp = data.obj || [];
    }
  },
  actions: {
    async gateSentryLatestDetails({commit}, obj) {
      let resp = await gateSentryLatestDetails(obj);
      commit('SENTRY_LATEST_DATA', resp);
    },
    async entranceSituationDetails({commit}, obj) {
      let resp = await entranceSituationDetails(obj);
      commit('ENTRANCE_SITUATION_DATA', resp);
    },
    async exportSituationDetails({commit}, obj) {
      let resp = await exportSituationDetails(obj);
      commit('EXPORT_SITUATION_DATA', resp);
    },
    async faceEventDetails({commit}, obj) {
      let resp = await faceEventDetails(obj);
      commit('FACE_EVENT_DATA', resp);
    },
    async faceVehicleMatchDetails({commit}, obj) {
      let resp = await faceVehicleMatchDetails(obj);
      commit('FACE_VEHICLE_MATCH_DATA', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async getPlantGateSentry({commit}, obj) {
      let resp = await getPlantGateSentry(obj);
      commit('PLANT_GATESENTRY', resp);
    },
  }
}
export default gateSentryLatest



// WEBPACK FOOTER //
// ./src/page/bd/gateSentryLatest/store/gateSentryLatest.store.js